module.exports = __webpack_public_path__ + "img/mainfon.a720051d.png";